module.exports = __webpack_public_path__ + "static/homepage-1-1-51e613a0a0a3d3a846b84ce368c261f0.png";